export function MiniBarChart() {
  const bars = [40, 65, 50, 80, 60, 95, 75];
  return (
    <svg viewBox="0 0 80 32" className="w-full h-8 mt-2" aria-hidden="true">
      {bars.map((h, i) => (
        <rect
          key={i}
          x={i * 12 + 2}
          y={32 - h * 0.3}
          width="8"
          height={h * 0.3}
          rx="2"
          fill="hsl(221 83% 53%)"
          opacity={0.4 + (i / bars.length) * 0.6}
        />
      ))}
    </svg>
  );
}
